import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader } from '@forge/common';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
}

const ChartCard = ({
  title,
  subtitle,
  actions,
  className,
  bodyClassName,
  children,
}: ChartCardProps) => {
  return (
    <Card
      className={`h-full border border-gray-200 shadow-sm dark:border-gray-800 ${className ?? ''}`}
    >
      <CardHeader title={title} subtitle={subtitle} slotRight={actions} />
      <CardContent top="none" className={bodyClassName}>
        {children}
      </CardContent>
    </Card>
  );
};

export type { ChartCardProps };
export default ChartCard;
